import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { Card, CardContent, CardTitle } from '@worldcoo/ui/components/card';
import { Button } from '@worldcoo/ui/components/button';
import { DonatingIllustration } from '@worldcoo/ui/custom/donating-illustration';
import { motion } from 'motion/react';
import { useOnboardingFormStore } from '@/lib/onboarding-form-store';

export const Route = createFileRoute('/ngos/onboarding/success')({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useLingui();
	const navigate = useNavigate();
	const reset = useOnboardingFormStore((s) => s.reset);

	const handleGoToProjects = (e: React.MouseEvent) => {
		e.preventDefault();
		reset();

		if (!document.startViewTransition) {
			navigate({ to: '/ngos/projects' });
			return;
		}

		const transition = document.startViewTransition(() => {
			navigate({ to: '/ngos/projects' });
			return new Promise<void>((resolve) => {
				const observer = new MutationObserver(() => {
					if (document.querySelector('[data-slot="sidebar"]')) {
						observer.disconnect();
						resolve();
					}
				});
				observer.observe(document.body, { childList: true, subtree: true });
				setTimeout(() => {
					observer.disconnect();
					resolve();
				}, 3000);
			});
		});
		// A superseded transition rejects `.ready` with InvalidStateError (TEC-3546).
		transition.ready.catch(() => {});
	};

	return (
		<div className="flex flex-col gap-6">
			<Card className="shadow-warm items-center text-center">
				<div className="w-full px-4">
					<div className="bg-primary/10 flex h-[202px] w-full items-center justify-center overflow-hidden rounded-xl">
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.5, ease: 'easeOut' }}
						>
							<DonatingIllustration className="text-primary mx-auto h-[180px]" />
						</motion.div>
					</div>
				</div>
				<CardContent className="flex flex-col gap-6">
					<CardTitle className="mt-8 text-2xl">{t`Registration Complete!`}</CardTitle>
					<Button size="xl" onClick={handleGoToProjects}>
						{t`Go to Projects`}
					</Button>
				</CardContent>
			</Card>
		</div>
	);
}
